// Backward-compatible facade for call sites that still import from
// `./lib/tauri`. All implementation lives behind `getAdapter()` so the same
// callers work in Tauri and browser modes without branching.

import { getAdapter } from './adapters';
import type { EnterpriseConfig } from './adapters';

export type { EnterpriseConfig };

export async function getEnterpriseConfig(): Promise<EnterpriseConfig | null> {
	return getAdapter().getEnterpriseConfig();
}

export async function setEnterpriseConfig(serverUrl: string, token: string): Promise<void> {
	return getAdapter().setEnterpriseConfig(serverUrl, token);
}

export async function exchangeAuthCode(serverUrl: string, code: string): Promise<void> {
	await getAdapter().exchangeAuthCode(serverUrl, code);
}

export async function switchAccount(): Promise<void> {
	return getAdapter().switchAccount();
}

export async function showLauncher(): Promise<void> {
	return getAdapter().showLauncher();
}
